import {
  isSigningReturnOutcome,
  type SigningReturnOutcome,
} from '@/lib/contracts/signing-return-message';

/**
 * @used-by: contract-svc (MPS-T04) — every embedded invite stores these paths as its `redirect_uri`,
 * `decline_redirect_uri` and `close_redirect_uri` (handover §5). Never rename them: an invite created
 * with them can stay open up to the 180-day deadline bound.
 *
 * Matched on `pathname` only. The query string is never read (AC-4.5 — S-3 observed none appended).
 */
const SIGNING_RETURN_PATH_RE = /^\/agreements\/[^/]+\/signing\/([a-z]+)\/?$/;

export function parseSigningReturnPath(pathname: string): SigningReturnOutcome | null {
  const outcome = SIGNING_RETURN_PATH_RE.exec(pathname)?.[1];
  return isSigningReturnOutcome(outcome) ? outcome : null;
}
